"use strict";

exports.__esModule = true;
exports.default = exports.RadioProgress = exports.AldeaSelectable = exports.Selectable = exports.Tabs = exports.SliderBar = exports.CheckBoxList = exports.OutlineFlat = exports.CircularOptions = exports.Basic = exports.Themeless = void 0;

var _styledComponents = require("styled-components");

var _styles = require("../styles");

function _templateObject100() {
  var data = _taggedTemplateLiteralLoose(["\n    color: ", ";\n    font-size: 14px;\n    letter-spacing: -0.5px;\n  "]);

  _templateObject100 = function _templateObject100() {
    return data;
  };

  return data;
}

function _templateObject99() {
  var data = _taggedTemplateLiteralLoose(["\n    display: flex;\n    align-items: center;\n    font-weight: 500;\n    cursor: pointer;\n\n    &:not(:last-child)::after {\n      content: none;\n      width: 30px;\n      height: 5px;\n      background: ", ";\n      border-radius: 20px;\n      margin: auto 10px;\n\n      ", " {\n        content: '';\n      }\n    }\n\n    ::before {\n      counter-increment: my-sec-counter;\n      content: counter(my-sec-counter);\n      width: 24px;\n      height: 24px;\n      min-width: 24px;\n      min-height: 24px;\n      background: ", ";\n      text-align: center;\n      margin-right: 10px;\n      border-radius: 50%;\n      font-size: 14px;\n      color: #FFFFFF;\n      letter-spacing: -0.5px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n    }\n\n    &:last-child::before {\n      margin-right: 0;\n\n      ", " {\n        margin-right: 10px;\n      }\n    }\n    &.doing.end::before {\n      margin-right: 10px;\n    }\n\n    .Optioner-text {\n      display: none;\n\n      ", " {\n        display: flex;\n        align-items: center;\n      }\n    }\n\n    &.doing {\n      &.begin, &.middle {\n        margin-right: auto;\n      }\n\n      /* &.end {\n        margin-left: auto;\n      } */\n\n      ", " {\n        &.middle, &.begin, &.end {\n          margin: 0;\n        }\n      }\n\n      .Optioner-text {\n        color: ", ";\n        display: flex;\n      }\n\n      ::before {\n        background: ", ";\n      }\n    }\n\n    &.done {\n      .Optioner-text {\n        color: ", ";\n      }\n\n      ::before {\n        background: ", ";\n      }\n    }\n  "]);

  _templateObject99 = function _templateObject99() {
    return data;
  };

  return data;
}

function _templateObject98() {
  var data = _taggedTemplateLiteralLoose(["\n    display: none;\n  "]);

  _templateObject98 = function _templateObject98() {
    return data;
  };

  return data;
}

function _templateObject97() {
  var data = _taggedTemplateLiteralLoose(["\n    display: flex;\n  "]);

  _templateObject97 = function _templateObject97() {
    return data;
  };

  return data;
}

function _templateObject96() {
  var data = _taggedTemplateLiteralLoose(["\n    counter-reset: my-sec-counter;\n  "]);

  _templateObject96 = function _templateObject96() {
    return data;
  };

  return data;
}

function _templateObject95() {
  var data = _taggedTemplateLiteralLoose(["\n    color: #BBB;\n    cursor: not-allowed;\n  "]);

  _templateObject95 = function _templateObject95() {
    return data;
  };

  return data;
}

function _templateObject94() {
  var data = _taggedTemplateLiteralLoose(["\n    color: #FFF;\n    background-color: ", ";\n    border-color: #157A9F;\n  "]);

  _templateObject94 = function _templateObject94() {
    return data;
  };

  return data;
}

function _templateObject93() {
  var data = _taggedTemplateLiteralLoose([""]);

  _templateObject93 = function _templateObject93() {
    return data;
  };

  return data;
}

function _templateObject92() {
  var data = _taggedTemplateLiteralLoose([""]);

  _templateObject92 = function _templateObject92() {
    return data;
  };

  return data;
}

function _templateObject91() {
  var data = _taggedTemplateLiteralLoose(["\n    font-size: 14px;\n    text-transform: capitalize;\n    letter-spacing: 3.7px;\n    margin-bottom: 10px;\n  "]);

  _templateObject91 = function _templateObject91() {
    return data;
  };

  return data;
}

function _templateObject90() {
  var data = _taggedTemplateLiteralLoose(["\n    display: none;\n  "]);

  _templateObject90 = function _templateObject90() {
    return data;
  };

  return data;
}

function _templateObject89() {
  var data = _taggedTemplateLiteralLoose(["\n    display: inline-flex;\n    justify-content: center;\n    align-items: center;\n\n    padding: 0;\n    min-width: 120px;\n    height: 40px;\n\n    background-color: #EEE;\n    color: #666;\n    font-size: 14px;\n    text-align: center;\n\n    transition: all 0.5s ease-out;\n    user-select: none;\n\n    cursor: pointer;\n\n    &:first-of-type {\n      border-top-left-radius: 3px;\n      border-bottom-left-radius: 3px;\n    }\n\n    &:nth-last-of-type(1) {\n      border-top-right-radius: 3px;\n      border-bottom-right-radius: 3px;\n    }\n  "]);

  _templateObject89 = function _templateObject89() {
    return data;
  };

  return data;
}

function _templateObject88() {
  var data = _taggedTemplateLiteralLoose([""]);

  _templateObject88 = function _templateObject88() {
    return data;
  };

  return data;
}

function _templateObject87() {
  var data = _taggedTemplateLiteralLoose(["\n    .Optioner-text {\n      color: ", ";\n\n      &:before {\n        display: flex;\n        position: relative;\n        content: '';\n\n        background-color: ", ";\n        width: 16px;\n        height: 16px;\n        border-radius: 100%;\n        border: 2px solid #fff;\n        padding: 2px;\n        box-shadow: 0px 0px 0px 1px ", ";\n        box-sizing: border-box;\n      }\n    }\n  "]);

  _templateObject87 = function _templateObject87() {
    return data;
  };

  return data;
}

function _templateObject86() {
  var data = _taggedTemplateLiteralLoose([""]);

  _templateObject86 = function _templateObject86() {
    return data;
  };

  return data;
}

function _templateObject85() {
  var data = _taggedTemplateLiteralLoose(["\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: flex-start;\n    height: 100%;\n    padding: 20px 0 0;\n\n    font-size: 11px;\n    color: ", ";\n    letter-spacing: -0.38px;\n    text-align: center;\n    line-height: 20px;\n\n    &:before {\n      display: flex;\n      flex-shrink: 0;\n      position: relative;\n      content: '';\n\n      background-color: #fff;\n      width: 16px;\n      height: 16px;\n      border-radius: 100%;\n      border: 2px solid #fff;\n      padding: 2px;\n      box-shadow: 0px 0px 0px 1px ", ";\n      box-sizing: border-box;\n      transition: all 0.3s ease;\n    }\n  "]);

  _templateObject85 = function _templateObject85() {
    return data;
  };

  return data;
}

function _templateObject84() {
  var data = _taggedTemplateLiteralLoose(["\n    color: ", ";\n  "]);

  _templateObject84 = function _templateObject84() {
    return data;
  };

  return data;
}

function _templateObject83() {
  var data = _taggedTemplateLiteralLoose(["\n    display: none;\n  "]);

  _templateObject83 = function _templateObject83() {
    return data;
  };

  return data;
}

function _templateObject82() {
  var data = _taggedTemplateLiteralLoose(["\n    display: flex;\n    justify-content: center;\n    width: auto;\n    flex: 1;\n    height: 70px;\n    cursor: pointer;\n    user-select: none;\n  "]);

  _templateObject82 = function _templateObject82() {
    return data;
  };

  return data;
}

function _templateObject81() {
  var data = _taggedTemplateLiteralLoose(["\n    position: relative;\n    display: flex;\n\n    &:before {\n      position: absolute;\n      left: 0;\n      display: flex;\n      content: '';\n      background-color: ", ";\n      width: 100%;\n      height: 8px;\n      border-radius: 100px;\n    }\n\n    &:after {\n      position: absolute;\n      left: 0;\n      display: flex;\n      content: '';\n      background-color: ", ";\n      width: 0px;\n      height: 8px;\n      border-radius: 100px;\n      transition: all 0.3s ease;\n    }\n  "]);

  _templateObject81 = function _templateObject81() {
    return data;
  };

  return data;
}

function _templateObject80() {
  var data = _taggedTemplateLiteralLoose(["\n    .Optioner-checkbox-group:after {\n      width: ", "%;\n    }\n  "]);

  _templateObject80 = function _templateObject80() {
    return data;
  };

  return data;
}

function _templateObject79() {
  var data = _taggedTemplateLiteralLoose(["\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n  "]);

  _templateObject79 = function _templateObject79() {
    return data;
  };

  return data;
}

function _templateObject78() {
  var data = _taggedTemplateLiteralLoose(["\n    color: ", ";\n  "]);

  _templateObject78 = function _templateObject78() {
    return data;
  };

  return data;
}

function _templateObject77() {
  var data = _taggedTemplateLiteralLoose(["\n    background: white;\n    display: flex;\n    flex-direction: column;\n  "]);

  _templateObject77 = function _templateObject77() {
    return data;
  };

  return data;
}

function _templateObject76() {
  var data = _taggedTemplateLiteralLoose(["\n    display: block;\n    overflow: initial;\n    border: none;\n\n    .Optioner-checkbox-group {\n      border-radius: 20px;\n      box-shadow: 0px 5px 20px -15px ", ";\n    }\n\n    .selected:hover {\n      cursor: default;\n      color: ", ";\n    }\n  "]);

  _templateObject76 = function _templateObject76() {
    return data;
  };

  return data;
}

function _templateObject75() {
  var data = _taggedTemplateLiteralLoose(["\n    display: none;\n    position: relative;\n    width: 100%;\n    background: ", ";\n    border: 0;\n    border-radius: 30px;\n    margin-top: 10px;\n    padding: 0px;\n    box-sizing: border-box;\n    outline: none;\n    overflow: hidden;\n  "]);

  _templateObject75 = function _templateObject75() {
    return data;
  };

  return data;
}

function _templateObject74() {
  var data = _taggedTemplateLiteralLoose([""]);

  _templateObject74 = function _templateObject74() {
    return data;
  };

  return data;
}

function _templateObject73() {
  var data = _taggedTemplateLiteralLoose([""]);

  _templateObject73 = function _templateObject73() {
    return data;
  };

  return data;
}

function _templateObject72() {
  var data = _taggedTemplateLiteralLoose(["\n    color: #4D4D4D;\n    padding-left: 1rem;\n    text-transform: capitalize;\n    letter-spacing: 0;\n    font-weight: 500;\n  "]);

  _templateObject72 = function _templateObject72() {
    return data;
  };

  return data;
}

function _templateObject71() {
  var data = _taggedTemplateLiteralLoose(["\n    display: none;\n  "]);

  _templateObject71 = function _templateObject71() {
    return data;
  };

  return data;
}

function _templateObject70() {
  var data = _taggedTemplateLiteralLoose(["\n    position: relative;\n    order: 1;\n    height: 40px;\n    padding: 10px;\n    box-sizing: border-box;\n    color: ", ";\n    background-color: ", ";\n    font-size: 14px;\n    border-radius: 0px;\n\n    &:hover {\n      cursor: pointer;\n      color: #000;\n      background: ", ";\n    }\n\n    &.selected:hover {\n      cursor: pointer;\n      background: ", ";\n    }\n  "]);

  _templateObject70 = function _templateObject70() {
    return data;
  };

  return data;
}

function _templateObject69() {
  var data = _taggedTemplateLiteralLoose(["\n    background-color: #bada55;\n    border-radius: 20px;\n    overflow: hidden;\n  "]);

  _templateObject69 = function _templateObject69() {
    return data;
  };

  return data;
}

function _templateObject68() {
  var data = _taggedTemplateLiteralLoose(["\n    position: relative;\n    z-index: 1;\n    &.focused {\n      z-index: 2;\n    }\n  "]);

  _templateObject68 = function _templateObject68() {
    return data;
  };

  return data;
}

function _templateObject67() {
  var data = _taggedTemplateLiteralLoose(["\n    color: ", ";\n    background: ", ";\n  "]);

  _templateObject67 = function _templateObject67() {
    return data;
  };

  return data;
}

function _templateObject66() {
  var data = _taggedTemplateLiteralLoose(["\n    position: absolute;\n    width: 100%;\n    box-sizing: border-box;\n    display: flex;\n    flex-direction: column;\n    background: white;\n  "]);

  _templateObject66 = function _templateObject66() {
    return data;
  };

  return data;
}

function _templateObject65() {
  var data = _taggedTemplateLiteralLoose(["\n    display: block;\n    overflow: initial;\n    border: none;\n\n    .Optioner-checkbox-group {\n      border-radius: 8px;\n      border: 1px solid ", ";\n      box-shadow: 0px 5px 20px -15px ", ";\n    }\n\n    .selected:hover {\n      cursor: default;\n      color: ", ";\n    }\n  "]);

  _templateObject65 = function _templateObject65() {
    return data;
  };

  return data;
}

function _templateObject64() {
  var data = _taggedTemplateLiteralLoose(["\n    position: relative;\n    display: none;\n    width: 100%;\n    background: ", ";\n    border: 1px solid ", ";\n    border-radius: 8px;\n\n    padding: 0px;\n    box-sizing: border-box;\n\n    outline: none;\n    overflow: hidden;\n  "]);

  _templateObject64 = function _templateObject64() {
    return data;
  };

  return data;
}

function _templateObject63() {
  var data = _taggedTemplateLiteralLoose(["\n    position: relative;\n    background: ", ";\n    border: 1px solid ", ";\n    border-radius: 8px;\n    height: 40px;\n    font-size: 14px;\n    padding: 10px;\n    box-sizing: border-box;\n  "]);

  _templateObject63 = function _templateObject63() {
    return data;
  };

  return data;
}

function _templateObject62() {
  var data = _taggedTemplateLiteralLoose([""]);

  _templateObject62 = function _templateObject62() {
    return data;
  };

  return data;
}

function _templateObject61() {
  var data = _taggedTemplateLiteralLoose([""]);

  _templateObject61 = function _templateObject61() {
    return data;
  };

  return data;
}

function _templateObject60() {
  var data = _taggedTemplateLiteralLoose(["\n    color: ", ";\n  "]);

  _templateObject60 = function _templateObject60() {
    return data;
  };

  return data;
}

function _templateObject59() {
  var data = _taggedTemplateLiteralLoose(["\n    display: none;\n  "]);

  _templateObject59 = function _templateObject59() {
    return data;
  };

  return data;
}

function _templateObject58() {
  var data = _taggedTemplateLiteralLoose(["\n    position: relative;\n    height: 40px;\n    padding: 10px;\n    box-sizing: border-box;\n    color: ", ";\n    background: ", ";\n    font-size: 14px;\n    border-radius: 8px;\n\n    &:hover {\n      cursor: pointer;\n      color: ", ";\n      background: ", ";\n    }\n\n    &.selected:hover {\n      cursor: pointer;\n      color: ", ";\n      background: ", ";\n    }\n  "]);

  _templateObject58 = function _templateObject58() {
    return data;
  };

  return data;
}

function _templateObject57() {
  var data = _taggedTemplateLiteralLoose(["\n    position: relative;\n    z-index: 1;\n\n    &.focused {\n      z-index: 2;\n    }\n  "]);

  _templateObject57 = function _templateObject57() {
    return data;
  };

  return data;
}

function _templateObject56() {
  var data = _taggedTemplateLiteralLoose(["\n    color: #FFFF;\n    font-weight: bold;\n    background-color: #76CA09;\n  "]);

  _templateObject56 = function _templateObject56() {
    return data;
  };

  return data;
}

function _templateObject55() {
  var data = _taggedTemplateLiteralLoose(["\n    text-transform: uppercase;\n    text-align: left;\n\n    font-size: 20px;\n    font-weight: 400;\n    letter-spacing: 5px;\n\n    display: block;\n    margin: 20px 0 10px;\n  "]);

  _templateObject55 = function _templateObject55() {
    return data;
  };

  return data;
}

function _templateObject54() {
  var data = _taggedTemplateLiteralLoose(["\n    display: none;\n  "]);

  _templateObject54 = function _templateObject54() {
    return data;
  };

  return data;
}

function _templateObject53() {
  var data = _taggedTemplateLiteralLoose(["\n    display: inline-flex;\n    justify-content: center;\n    align-items: center;\n    box-sizing: border-box;\n\n    min-height: 44px;\n    padding: 0 20px;\n    background-color: #E5E5E5;\n    color: #808184;\n    border: 0;\n\n    font-size: 16px;\n    text-align: center;\n\n    transition: all 0.5s ease-out;\n    user-select: none;\n    cursor: pointer;\n\n\n    &:first-of-type {\n      border-top-left-radius: 30px;\n      border-bottom-left-radius: 30px;\n    }\n\n    &:nth-last-of-type(1) {\n      border-top-right-radius: 30px;\n      border-bottom-right-radius: 30px;\n    }\n  "]);

  _templateObject53 = function _templateObject53() {
    return data;
  };

  return data;
}

function _templateObject52() {
  var data = _taggedTemplateLiteralLoose(["\n    display: flex;\n    flex-wrap: nowrap;\n    flex-direction: column;\n\n    .Optioner-checkbox-group {\n      display: flex;\n      flex-wrap: nowrap;\n      justify-content: flex-start;\n    }\n  "]);

  _templateObject52 = function _templateObject52() {
    return data;
  };

  return data;
}

function _templateObject51() {
  var data = _taggedTemplateLiteralLoose(["\n    background-color: ", ";\n    color: ", ";\n  "]);

  _templateObject51 = function _templateObject51() {
    return data;
  };

  return data;
}

function _templateObject50() {
  var data = _taggedTemplateLiteralLoose([""]);

  _templateObject50 = function _templateObject50() {
    return data;
  };

  return data;
}

function _templateObject49() {
  var data = _taggedTemplateLiteralLoose([""]);

  _templateObject49 = function _templateObject49() {
    return data;
  };

  return data;
}

function _templateObject48() {
  var data = _taggedTemplateLiteralLoose(["\n    font-size: 16px;\n    font-weight: bold;\n    text-transform: capitalize;\n    color: ", ";\n\n    position: relative;\n    right: 140px;\n    letter-spacing: -0.4px;\n  "]);

  _templateObject48 = function _templateObject48() {
    return data;
  };

  return data;
}

function _templateObject47() {
  var data = _taggedTemplateLiteralLoose(["\n    display: none;\n  "]);

  _templateObject47 = function _templateObject47() {
    return data;
  };

  return data;
}

function _templateObject46() {
  var data = _taggedTemplateLiteralLoose(["\n    display: inline-flex;\n    justify-content: center;\n    align-items: center;\n    box-sizing: border-box;\n\n    // width: auto;\n    min-width: 140px;\n    height: 40px;\n    margin: 10px 0px;\n\n    padding: 0px 30px;\n    background-color: ", ";\n    border-radius: 25px;\n\n    color: ", ";\n    font-size: 18px;\n    text-align: center;\n    font-weight: bold;\n\n    transition: all 0.5s ease-out;\n    cursor: pointer;\n  "]);

  _templateObject46 = function _templateObject46() {
    return data;
  };

  return data;
}

function _templateObject45() {
  var data = _taggedTemplateLiteralLoose(["\n    display: flex;\n    justify-content: space-between;\n    flex-wrap: wrap;\n\n    margin: 15px 0;\n\n    .Optioner-checkbox-group {\n      display: flex;\n      flex-wrap: wrap;\n      justify-content: space-between;\n\n      width: 100%;\n    }\n  "]);

  _templateObject45 = function _templateObject45() {
    return data;
  };

  return data;
}

function _templateObject44() {
  var data = _taggedTemplateLiteralLoose([""]);

  _templateObject44 = function _templateObject44() {
    return data;
  };

  return data;
}

function _templateObject43() {
  var data = _taggedTemplateLiteralLoose(["\n    color: #FFFF;\n    font-weight: bold;\n    background-color: ", ";\n    border-top-left-radius: 20px;\n    border-top-right-radius: 20px;\n  "]);

  _templateObject43 = function _templateObject43() {
    return data;
  };

  return data;
}

function _templateObject42() {
  var data = _taggedTemplateLiteralLoose(["\n    color: ", ";\n    text-transform: uppercase;\n    text-align: left;\n\n    font-size: 20px;\n    font-weight: 400;\n    letter-spacing: 5px;\n\n    display: block;\n    margin: 20px 0 10px;\n  "]);

  _templateObject42 = function _templateObject42() {
    return data;
  };

  return data;
}

function _templateObject41() {
  var data = _taggedTemplateLiteralLoose(["\n    display: none;\n  "]);

  _templateObject41 = function _templateObject41() {
    return data;
  };

  return data;
}

function _templateObject40() {
  var data = _taggedTemplateLiteralLoose(["\n    display: inline-flex;\n    justify-content: center;\n    align-items: center;\n\n    padding: 0px 20px;\n    min-width: 132px;\n    height: 40px;\n    background-color: transparent;\n    color: ", ";\n    border: 0;\n    border-top-left-radius: 20px;\n    border-top-right-radius: 20px;\n\n    font-size: 18px;\n    text-align: center;\n\n    transition: all 0.5s ease-out;\n    user-select: none;\n    cursor: pointer;\n  "]);

  _templateObject40 = function _templateObject40() {
    return data;
  };

  return data;
}

function _templateObject39() {
  var data = _taggedTemplateLiteralLoose([""]);

  _templateObject39 = function _templateObject39() {
    return data;
  };

  return data;
}

function _templateObject38() {
  var data = _taggedTemplateLiteralLoose(["\n    color: ", ";\n    &::after {\n      background-color: ", ";\n    }\n  "]);

  _templateObject38 = function _templateObject38() {
    return data;
  };

  return data;
}

function _templateObject37() {
  var data = _taggedTemplateLiteralLoose(["\n    display: none;\n  "]);

  _templateObject37 = function _templateObject37() {
    return data;
  };

  return data;
}

function _templateObject36() {
  var data = _taggedTemplateLiteralLoose(["\n    color: ", ";\n    text-transform: uppercase;\n\n    font-size: 20px;\n    font-weight: bold;\n    letter-spacing: 5px;\n\n    display: block;\n    margin: 20px 0 10px;\n  "]);

  _templateObject36 = function _templateObject36() {
    return data;
  };

  return data;
}

function _templateObject35() {
  var data = _taggedTemplateLiteralLoose(["\n    position: relative;\n    display: inline-flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n\n    padding: 0;\n    width: 100%;\n    min-width: 96px;\n    height: 40px;\n    background-color: transparent;\n\n    color: ", ";\n    font-size: 14px;\n    font-weight: bold;\n\n    text-align: center;\n\n    transition: all 0.5s ease-out;\n    user-select: none;\n\n    cursor: pointer;\n\n    &:first-child::after {\n      border-top-left-radius: 100px;\n      border-bottom-left-radius: 100px;\n    }\n\n\n    &:last-child::after {\n      border-top-right-radius: 100px;\n      border-bottom-right-radius: 100px;\n    }\n\n    &::after {\n      content: '';\n      position: absolute;\n      bottom: 0;\n      background-color: ", ";\n      width: 100%;\n      height: 4px;\n      transition: all 0.5s ease;\n    }\n  "]);

  _templateObject35 = function _templateObject35() {
    return data;
  };

  return data;
}

function _templateObject34() {
  var data = _taggedTemplateLiteralLoose(["\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n\n    margin: 15px 0;\n\n    .Optioner-box-container {\n      width: 100%;\n    }\n\n    .Optioner-checkbox-group {\n      display: flex;\n      flex-wrap: nowrap;\n      justify-content: center;\n      width: 100%;\n    }\n  "]);

  _templateObject34 = function _templateObject34() {
    return data;
  };

  return data;
}

function _templateObject33() {
  var data = _taggedTemplateLiteralLoose(["\n    margin-left: 35px;\n  "]);

  _templateObject33 = function _templateObject33() {
    return data;
  };

  return data;
}

function _templateObject32() {
  var data = _taggedTemplateLiteralLoose(["\n    ::before {\n      content: '';\n      background-color: ", ";\n      border-color: ", ";\n    }\n\n  ::after {\n    content: '\u2714';\n    position: absolute;\n    left: 13px;\n    bottom: 27px;\n    display: flex;\n    align-self: flex-start;\n\n    width: 0px;\n    height: 0px;\n    color: white;\n    font-size: 13px;\n  }\n  "]);

  _templateObject32 = function _templateObject32() {
    return data;
  };

  return data;
}

function _templateObject31() {
  var data = _taggedTemplateLiteralLoose(["\n    font-size: 13px;\n    font-weight: 500;\n    text-transform: uppercase;\n    letter-spacing: 3.7px;\n\n    margin-bottom: 10px;\n"]);

  _templateObject31 = function _templateObject31() {
    return data;
  };

  return data;
}

function _templateObject30() {
  var data = _taggedTemplateLiteralLoose(["\n    display: none;\n  "]);

  _templateObject30 = function _templateObject30() {
    return data;
  };

  return data;
}

function _templateObject29() {
  var data = _taggedTemplateLiteralLoose(["\n    position: relative;\n    display: inline-flex;\n    justify-content: flex-start;\n    align-items: center;\n\n    padding: 0;\n    min-width: 96px;\n    height: 40px;\n\n    color: ", ";\n    font-size: 18px;\n    text-align: center;\n\n    transition: all 0.5s ease-out;\n    user-select: none;\n\n    cursor: pointer;\n\n    ::before {\n      content: '';\n      position: absolute;\n      left: 7px;\n\n      width: 20px;\n      height: 20px;\n\n      border-radius: 4px;\n      border: solid 1.5px ", ";\n    }\n  "]);

  _templateObject29 = function _templateObject29() {
    return data;
  };

  return data;
}

function _templateObject28() {
  var data = _taggedTemplateLiteralLoose(["\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n\n    margin: 15px 0;\n\n    .Optioner-checkbox-group {\n      display: flex;\n      flex-direction: column;\n      flex-wrap: wrap;\n      justify-content: center;\n\n      width: 100%;\n    }\n  "]);

  _templateObject28 = function _templateObject28() {
    return data;
  };

  return data;
}

function _templateObject27() {
  var data = _taggedTemplateLiteralLoose(["\n    color: #FFFF;\n    background-color: ", ";\n    border-color: ", ";\n  "]);

  _templateObject27 = function _templateObject27() {
    return data;
  };

  return data;
}

function _templateObject26() {
  var data = _taggedTemplateLiteralLoose(["\n    display: none;\n  "]);

  _templateObject26 = function _templateObject26() {
    return data;
  };

  return data;
}

function _templateObject25() {
  var data = _taggedTemplateLiteralLoose(["\n    color: ", ";\n    text-transform: uppercase;\n    text-align: left;\n\n    font-size: 20px;\n    font-weight: 400;\n    letter-spacing: 5px;\n\n    display: block;\n    margin: 20px 0 10px;\n  "]);

  _templateObject25 = function _templateObject25() {
    return data;
  };

  return data;
}

function _templateObject24() {
  var data = _taggedTemplateLiteralLoose(["\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    box-sizing: border-box;\n\n    padding: 7px 10px;\n    margin: 10px 7px 10px 0;\n    width: auto;\n    min-width: 35px;\n    border-radius: 25px;\n\n    color: ", ";\n    background-color: transparent;\n    border: 1px solid ", ";\n\n    font-weight: 500;\n    font-size: 16px;\n    letter-spacing: -0.45px;\n    text-align: center;\n    text-transform: capitalize;\n\n    transition: all 0.3s ease;\n    cursor: pointer;\n  "]);

  _templateObject24 = function _templateObject24() {
    return data;
  };

  return data;
}

function _templateObject23() {
  var data = _taggedTemplateLiteralLoose(["\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n\n    margin: 15px 0;\n\n    .Optioner-checkbox-group {\n      display: flex;\n      flex-wrap: wrap;\n      justify-content: center;\n\n      width: 100%;\n    }\n  "]);

  _templateObject23 = function _templateObject23() {
    return data;
  };

  return data;
}

function _templateObject22() {
  var data = _taggedTemplateLiteralLoose(["\n    width: 35px;\n  "]);

  _templateObject22 = function _templateObject22() {
    return data;
  };

  return data;
}

function _templateObject21() {
  var data = _taggedTemplateLiteralLoose(["\n    background-color: ", ";\n  "]);

  _templateObject21 = function _templateObject21() {
    return data;
  };

  return data;
}

function _templateObject20() {
  var data = _taggedTemplateLiteralLoose([""]);

  _templateObject20 = function _templateObject20() {
    return data;
  };

  return data;
}

function _templateObject19() {
  var data = _taggedTemplateLiteralLoose(["\n    position: absolute;\n    left: 0;\n    bottom: -50px;\n    width: 100%;\n    height: 40px;\n  "]);

  _templateObject19 = function _templateObject19() {
    return data;
  };

  return data;
}

function _templateObject18() {
  var data = _taggedTemplateLiteralLoose(["\n    display: none;\n  "]);

  _templateObject18 = function _templateObject18() {
    return data;
  };

  return data;
}

function _templateObject17() {
  var data = _taggedTemplateLiteralLoose(["\n    position: relative;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    width: 103px;\n    height: 103px;\n    margin: 0 10px 60px;\n\n    border-radius: 100px;\n    background-color: #DADADA;\n\n    transition: background-color 0.5s;\n\n    color: ", ";\n    font-size: 16px;\n    text-align: center;\n  "]);

  _templateObject17 = function _templateObject17() {
    return data;
  };

  return data;
}

function _templateObject16() {
  var data = _taggedTemplateLiteralLoose(["\n      display: flex;\n      flex-wrap: wrap;\n      justify-content: baseline;\n    "]);

  _templateObject16 = function _templateObject16() {
    return data;
  };

  return data;
}

function _templateObject15() {
  var data = _taggedTemplateLiteralLoose([""]);

  _templateObject15 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14() {
  var data = _taggedTemplateLiteralLoose(["\n    color: #FFF;\n    background-color: #1EACDF;\n    border-color: #157A9F;\n  "]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteralLoose([""]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteralLoose([""]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteralLoose(["\n    font-size: 13px;\n    font-weight: 500;\n    text-transform: uppercase;\n    letter-spacing: 3.7px;\n    margin-bottom: 10px;\n  "]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteralLoose(["\n    display: none;\n  "]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteralLoose(["\n    display: inline-flex;\n    justify-content: center;\n    align-items: center;\n\n    padding: 0;\n    min-width: 96px;\n    height: 40px;\n    background-color: #FFF;\n    border: 2px solid #E1E1E1;\n\n    color: #E1E1E1;\n    font-size: 18px;\n    text-align: center;\n\n    transition: all 0.5s ease-out;\n    user-select: none;\n\n    cursor: pointer;\n\n    &:first-of-type {\n      border-top-left-radius: 6px;\n      border-bottom-left-radius: 6px;\n    }\n\n    &:nth-last-of-type(1) {\n      border-top-right-radius: 6px;\n      border-bottom-right-radius: 6px;\n    }\n  "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteralLoose([""]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteralLoose([""]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteralLoose([""]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose([""]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose([""]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n    display: none;\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose([""]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose([""]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

var KineduPalette = _styles.colorPalettes.KineduPalette,
    AldeaPalette = _styles.colorPalettes.AldeaPalette,
    MiscPalette = _styles.colorPalettes.MiscPalette;
var Themeless = {
  wrapper: (0, _styledComponents.css)(_templateObject()),
  box: (0, _styledComponents.css)(_templateObject2()),
  input: (0, _styledComponents.css)(_templateObject3()),
  label: (0, _styledComponents.css)(_templateObject4()),
  text: (0, _styledComponents.css)(_templateObject5()),
  textContainer: (0, _styledComponents.css)(_templateObject6()),
  selected: (0, _styledComponents.css)(_templateObject7())
};
exports.Themeless = Themeless;
var Basic = {
  wrapper: (0, _styledComponents.css)(_templateObject8()),
  box: (0, _styledComponents.css)(_templateObject9()),
  input: (0, _styledComponents.css)(_templateObject10()),
  label: (0, _styledComponents.css)(_templateObject11()),
  text: (0, _styledComponents.css)(_templateObject12()),
  textContainer: (0, _styledComponents.css)(_templateObject13()),
  selected: (0, _styledComponents.css)(_templateObject14())
};
exports.Basic = Basic;
var CircularOptions = {
  container: (0, _styledComponents.css)(_templateObject15()),
  checkboxGroup: (0, _styledComponents.css)(_templateObject16()),
  box: (0, _styledComponents.css)(_templateObject17(), KineduPalette.darkGray),
  input: (0, _styledComponents.css)(_templateObject18()),
  text: (0, _styledComponents.css)(_templateObject19()),
  textContainer: (0, _styledComponents.css)(_templateObject20()),
  selected: (0, _styledComponents.css)(_templateObject21(), KineduPalette.health),
  image: (0, _styledComponents.css)(_templateObject22())
};
exports.CircularOptions = CircularOptions;
var OutlineFlat = {
  wrapper: (0, _styledComponents.css)(_templateObject23()),
  box: (0, _styledComponents.css)(_templateObject24(), KineduPalette.kinedu, KineduPalette.kinedu),
  label: (0, _styledComponents.css)(_templateObject25(), KineduPalette.kinedu),
  input: (0, _styledComponents.css)(_templateObject26()),
  selected: (0, _styledComponents.css)(_templateObject27(), KineduPalette.kinedu, KineduPalette.kinedu)
};
exports.OutlineFlat = OutlineFlat;
var CheckBoxList = {
  wrapper: (0, _styledComponents.css)(_templateObject28()),
  box: (0, _styledComponents.css)(_templateObject29(), KineduPalette.shadeDark, KineduPalette.shadeDark),
  input: (0, _styledComponents.css)(_templateObject30()),
  label: (0, _styledComponents.css)(_templateObject31()),
  selected: (0, _styledComponents.css)(_templateObject32(), KineduPalette.kinedu, KineduPalette.kinedu),
  textContainer: (0, _styledComponents.css)(_templateObject33())
};
exports.CheckBoxList = CheckBoxList;
var SliderBar = {
  wrapper: (0, _styledComponents.css)(_templateObject34()),
  box: (0, _styledComponents.css)(_templateObject35(), KineduPalette.shadeMediumDark, KineduPalette.shadeMediumLight),
  label: (0, _styledComponents.css)(_templateObject36(), KineduPalette.shadeMediumDark),
  input: (0, _styledComponents.css)(_templateObject37()),
  selected: (0, _styledComponents.css)(_templateObject38(), KineduPalette.kinedu, KineduPalette.kinedu)
};
exports.SliderBar = SliderBar;
var Tabs = {
  wrapper: (0, _styledComponents.css)(_templateObject39()),
  box: (0, _styledComponents.css)(_templateObject40(), KineduPalette.kinedu),
  input: (0, _styledComponents.css)(_templateObject41()),
  label: (0, _styledComponents.css)(_templateObject42(), KineduPalette.kinedu),
  selected: (0, _styledComponents.css)(_templateObject43(), KineduPalette.kineduShade)
};
exports.Tabs = Tabs;
var Pills = {
  wrapper: (0, _styledComponents.css)(_templateObject44()),
  checkboxGroup: (0, _styledComponents.css)(_templateObject45()),
  box: (0, _styledComponents.css)(_templateObject46(), KineduPalette.shadeLighter, KineduPalette.shadeDark),
  input: (0, _styledComponents.css)(_templateObject47()),
  label: (0, _styledComponents.css)(_templateObject48(), KineduPalette.shadeDark),
  text: (0, _styledComponents.css)(_templateObject49()),
  textContainer: (0, _styledComponents.css)(_templateObject50()),
  selected: (0, _styledComponents.css)(_templateObject51(), KineduPalette.kinedu, MiscPalette.white)
};
var LongPill = {
  wrapper: (0, _styledComponents.css)(_templateObject52()),
  box: (0, _styledComponents.css)(_templateObject53()),
  input: (0, _styledComponents.css)(_templateObject54()),
  label: (0, _styledComponents.css)(_templateObject55()),
  selected: (0, _styledComponents.css)(_templateObject56())
};
var Selectable = {
  wrapper: (0, _styledComponents.css)(_templateObject57()),
  box: (0, _styledComponents.css)(_templateObject58(), KineduPalette.shadeMediumDark, MiscPalette.white, KineduPalette.shadeMedium, KineduPalette.shadeLighter, KineduPalette.shadeMediumDark, MiscPalette.white),
  input: (0, _styledComponents.css)(_templateObject59()),
  label: (0, _styledComponents.css)(_templateObject60(), KineduPalette.shadeDark),
  text: (0, _styledComponents.css)(_templateObject61()),
  textContainer: (0, _styledComponents.css)(_templateObject62()),
  inputHeader: (0, _styledComponents.css)(_templateObject63(), MiscPalette.white, KineduPalette.shadeMedium),
  boxContainer: (0, _styledComponents.css)(_templateObject64(), MiscPalette.white, KineduPalette.shadeMedium),
  boxContainerFocused: (0, _styledComponents.css)(_templateObject65(), KineduPalette.shadeMedium, KineduPalette.shadeDarker, KineduPalette.shadeMediumDark),
  checkboxGroup: (0, _styledComponents.css)(_templateObject66()),
  selected: (0, _styledComponents.css)(_templateObject67(), KineduPalette.shadeMediumDark, KineduPalette.shadeLighter)
};
exports.Selectable = Selectable;
var AldeaSelectable = {
  wrapper: (0, _styledComponents.css)(_templateObject68()),
  content: (0, _styledComponents.css)(_templateObject69()),
  box: (0, _styledComponents.css)(_templateObject70(), KineduPalette.shadeMedium, MiscPalette.white, KineduPalette.shadeLighter, MiscPalette.white),
  input: (0, _styledComponents.css)(_templateObject71()),
  label: (0, _styledComponents.css)(_templateObject72()),
  text: (0, _styledComponents.css)(_templateObject73()),
  textContainer: (0, _styledComponents.css)(_templateObject74()),
  boxContainer: (0, _styledComponents.css)(_templateObject75(), MiscPalette.blue),
  boxContainerFocused: (0, _styledComponents.css)(_templateObject76(), KineduPalette.shadeDarker, KineduPalette.shadeMediumDark),
  checkboxGroup: (0, _styledComponents.css)(_templateObject77()),
  selected: (0, _styledComponents.css)(_templateObject78(), KineduPalette.shadeDarker)
};
exports.AldeaSelectable = AldeaSelectable;
var RadioProgress = {
  wrapper: (0, _styledComponents.css)(_templateObject79()),
  dynamicTheme: function dynamicTheme(total, index) {
    return (0, _styledComponents.css)(_templateObject80(), (index + 1) * 100 / total);
  },
  checkboxGroup: (0, _styledComponents.css)(_templateObject81(), KineduPalette.shadeLight, KineduPalette.cognitiveLight30),
  box: (0, _styledComponents.css)(_templateObject82()),
  input: (0, _styledComponents.css)(_templateObject83()),
  label: (0, _styledComponents.css)(_templateObject84(), KineduPalette.shadeDark),
  text: (0, _styledComponents.css)(_templateObject85(), KineduPalette.shadeMediumDark, KineduPalette.shadeMedium),
  textContainer: (0, _styledComponents.css)(_templateObject86()),
  selected: (0, _styledComponents.css)(_templateObject87(), KineduPalette.shadeDark, KineduPalette.cognitive, KineduPalette.cognitive)
};
exports.RadioProgress = RadioProgress;
var LegacyAldeaSquaredFlat = {
  wrapper: (0, _styledComponents.css)(_templateObject88()),
  box: (0, _styledComponents.css)(_templateObject89()),
  input: (0, _styledComponents.css)(_templateObject90()),
  label: (0, _styledComponents.css)(_templateObject91()),
  text: (0, _styledComponents.css)(_templateObject92()),
  textContainer: (0, _styledComponents.css)(_templateObject93()),
  selected: (0, _styledComponents.css)(_templateObject94(), AldeaPalette.blue),
  disabled: (0, _styledComponents.css)(_templateObject95())
};
var StepByStep = {
  wrapper: (0, _styledComponents.css)(_templateObject96()),
  checkboxGroup: (0, _styledComponents.css)(_templateObject97()),
  input: (0, _styledComponents.css)(_templateObject98()),
  box: (0, _styledComponents.css)(_templateObject99(), KineduPalette.shadeLight, _styles.breakPoints.desktop, KineduPalette.shadeMedium, _styles.breakPoints.desktop, _styles.breakPoints.desktop, _styles.breakPoints.desktop, KineduPalette.shadeDark, KineduPalette.cognitive, KineduPalette.shadeMediumDark, KineduPalette.kinedu),
  text: (0, _styledComponents.css)(_templateObject100(), KineduPalette.shadeMedium)
};
var OptionerThemes = {
  Themeless: Themeless,
  Basic: Basic,
  CircularOptions: CircularOptions,
  OutlineFlat: OutlineFlat,
  CheckBoxList: CheckBoxList,
  SliderBar: SliderBar,
  Tabs: Tabs,
  Pills: Pills,
  LongPill: LongPill,
  Selectable: Selectable,
  AldeaSelectable: AldeaSelectable,
  RadioProgress: RadioProgress,
  LegacyAldeaSquaredFlat: LegacyAldeaSquaredFlat,
  StepByStep: StepByStep
};
var _default = OptionerThemes;
exports.default = _default;